import React , { useState, useEffect } from 'react';

// Toast
import { toast } from 'react-toastify';

// Axios
import axios from 'axios';

// MUI Components
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

// Components
import ErrorLogRow from './error-log-row';

const ErrorLogsModal = ({ site, setSelectedSite }) => {

    const [ open, setOpen ] = useState(false);
    const [ errorLogGroups, setErrorLogGroups ] = useState([]);

    const getErrorLogs = () => {
        axios.get(`/site/${site.id}/error-logs`).then(response => {
            if( response.data.success ){
                setErrorLogGroups(response.data.error_log_groups);
            }
            else{
                toast.error(response.data.message);
            }
        });
    }

    const clearLog = ( id ) => {
        setErrorLogGroups(errorLogGroups.map(group => ({
            ...group,
            error_logs: group.error_logs.filter(errorLog => errorLog.id !== id),
        })));
    }

    const handleClose = () => {
        setOpen(false);
    }

    useEffect(() => {
        if( site ){
            getErrorLogs();
            setOpen(true);
        }
    }, [site]);

    useEffect(() => {
        if( !open ){
            setSelectedSite(null);
        }
    }, [open]);

    const groupsWithLogs = errorLogGroups.filter(group => group.error_logs.length);

    return (
        <>
            {site && (
                <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
                    <DialogContent>
                        {groupsWithLogs.length ? (
                            groupsWithLogs.map((group) => (
                                <React.Fragment key={group.domain}>
                                    <Typography className='error-logs-modal-title' variant='subtitle1'>{group.domain}</Typography>
                                    {group.error_logs.map((errorLog) => (
                                        <ErrorLogRow key={errorLog.id} errorLog={errorLog} clearLog={clearLog} />
                                    ))}
                                </React.Fragment>
                            ))
                        ) : <p>No files found</p>}
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' color='error' onClick={handleClose}>Close</Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );

}

export default ErrorLogsModal;